import {
  Autocomplete,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import {
  changeErrorMassageVideo,
  changeImagePreview,
  changeIsCreateMap,
  changeMiniHubName,
  changePicChoose,
  changePicPhone,
  changePicSearch,
  changePicSearchDebounce,
  changeStatus,
  changeVideoPreview,
  clearData,
  clickIsPreviewImage,
  clickIsVideoPreview,
  deleteMiniHubImage,
  deleteVideoPreview,
  getAddressFix,
  getCellSelectedDetailsCreateMap,
  getColCreateMap,
  getCoordinateFix,
  getEntranceCreateMap,
  getIdToko,
  getImagePreviewMiniHubAdd,
  getIsCreateMap,
  getIsImagePreviewMiniHubAdd,
  getIsLoadigMiniHub,
  getIsMaxSizeImageMiniHubAdd,
  getIsMaxSizeVideoMiniHubAdd,
  getIsVideoPreviewMiniHubAdd,
  getMiniHubAddAllState,
  getMiniHubImage,
  getMinihubName,
  getPicChooseMiniHubAdd,
  getPicPhoneMiniHubAdd,
  getPicSearchDebounceMiniHubAdd,
  getPicSearchMiniHubAdd,
  getRowCreateMap,
  getSubHubId,
  getSubsidiaryIdMiniHub,
  getVideoMiniHubAdd,
  getVideoPreviewMiniHubAdd,
  getstatusMiniHubAdd,
  inputMiniHubImage,
  inputVideoPreview,
} from "../../../../../../../store/hub/miniHub/miniHubAdd";
import CustomInput from "../../../../../../../components/shared/CustomInput";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CustomCard from "../../../../../../../components/shared/CustomCard";
import { Map } from "pigeon-maps";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import {
  fetchPic,
  getPicList,
  getPicLoading,
} from "../../../../../../../store/pic/pic";
import { useEffect, useRef, useState } from "react";
import debounce from "lodash.debounce";
import CustomAntSwitch from "../../../../../../../components/shared/CustomAntSwitch";
import CustomButton from "../../../../../../../components/shared/CustomButton";
import SetupAddressMiniHub from "./CreateAddress/SetupAddress";
import CreateMapMiniHub from "./CreateMapMiniHub";
import {
  addNewMiniHub,
  addNewMultipleRack,
} from "../../../../../../../api/hubs";
import { inputNotifHub } from "../../../../../../../store/hub/notifHub";
import { createSearchParams, useSearchParams } from "react-router-dom";

function FormMiniHubAdd({ setIsOpenAddNewMiniHub, setMiniSubSelected }) {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const updatedSearchParams = createSearchParams(searchParams);
  const subHubIdRef = useRef(searchParams.get("minihub-overview") || null);
  const dispatch = useDispatch();
  const miniHubName = useSelector(getMinihubName);
  const isLoading = useSelector(getIsLoadigMiniHub);
  const subsidiaryId = useSelector(getSubsidiaryIdMiniHub);
  const idToko = useSelector(getIdToko);
  const subHubId = useSelector(getSubHubId);
  const coordinate = useSelector(getCoordinateFix);
  const {
    mapInputType,
    placeGetByName,
    placeGetByCoordinate,
    errorMassageVideo,
  } = useSelector(getMiniHubAddAllState);

  // add image
  const miniHubImage = useSelector(getMiniHubImage);
  const isMaxSizeImage = useSelector(getIsMaxSizeImageMiniHubAdd);
  const linkPhotoPreview = useSelector(getImagePreviewMiniHubAdd);
  const isImagePreview = useSelector(getIsImagePreviewMiniHubAdd);

  // add video
  const miniHubVideo = useSelector(getVideoMiniHubAdd);
  const isMaxSizeVideo = useSelector(getIsMaxSizeVideoMiniHubAdd);
  const linkVideoPreview = useSelector(getVideoPreviewMiniHubAdd);
  const isVideoPreview = useSelector(getIsVideoPreviewMiniHubAdd);

  // add PIC
  const picList = useSelector(getPicList);
  const picLoading = useSelector(getPicLoading);
  const picChoose = useSelector(getPicChooseMiniHubAdd);
  const picSearch = useSelector(getPicSearchMiniHubAdd);
  const picSearchDebounce = useSelector(getPicSearchDebounceMiniHubAdd);
  const picNumber = useSelector(getPicPhoneMiniHubAdd);

  // add phone number
  const picPhone = useSelector(getPicPhoneMiniHubAdd);

  // add address
  const address = useSelector(getAddressFix);
  const isCreateMap = useSelector(getIsCreateMap);
  const col = useSelector(getColCreateMap);
  const row = useSelector(getRowCreateMap);
  const entrance = useSelector(getEntranceCreateMap);
  const dataDetailRack = useSelector(getCellSelectedDetailsCreateMap);

  useEffect(() => {
    dispatch(fetchPic(picSearchDebounce));
  }, [picSearchDebounce]);

  const picSearchInDebounce = useRef(
    debounce((value) => {
      dispatch(changePicSearchDebounce(value));
    }, 1000)
  ).current;

  // preview map address
  const [isMapOpen, setIsMapOpen] = useState(false);

  // submit data

  const [loadingSubmit, setLoadingSubmit] = useState(false);

  // submit data
  const handleSubmit = () => {
    let datas = {
      subsidiaryId: subsidiaryId,
      subHubId: subHubId,
      name: miniHubName,
      idToko: idToko,
      mapColumn: col + 2,
      mapRow: row + 2,
      idKustomer: picChoose.idKustomer,
      status: status ? "active" : "inactive",
      address: address,
      nohp: picNumber,
      lat: coordinate[0],
      lon: coordinate[1],
      typeInput: mapInputType === "manual" ? "manual" : "map",
    };

    if (miniHubImage.length !== 0) {
      datas["images"] = miniHubImage.join(",");
    }
    if (miniHubVideo.length !== 0) {
      datas["videos"] = miniHubVideo.join(",");
    }
    if (entrance.length !== 0) {
      datas["entrancePosition"] = entrance.join(",");
    }
    if (mapInputType === "manual") {
      const { formatted: citydistric } = placeGetByName;
      datas["cityDistrict"] = citydistric;
    } else {
      if (!placeGetByCoordinate?.statusCode) {
        const { formatted: citydistric } = placeGetByCoordinate;
        datas["cityDistrict"] = citydistric;
      }
    }

    const createRacks = async (idToko, subHubId, id, nama) => {
      try {
        let racks = dataDetailRack.map((item) => {
          let value = {
            idToko: idToko,
            subHubId: subHubId,
            miniHubId: id,
            name: item.name,
            images: "",
            videos: "",
            column: item.column,
            row: item.row,
            columnPosition: item.columnPosition.join(","),
            description: item.description,
            width: 0,
            height: 0,
            length: 0,
            weight: 0,
          };

          return value;
        });
        const { data } = await addNewMultipleRack(racks);
      } catch (error) {
        console.error(error);
      } finally {
        dispatch(
          inputNotifHub({
            key: "addminihub",
            text: `${nama} has been successfully added`,
          })
        );
        setLoadingSubmit(false);
        dispatch(clearData());
        setMiniSubSelected(subHubId);
        setIsOpenAddNewMiniHub(false);
        updatedSearchParams.set("minihub-overview", subHubId);
        setSearchParams(updatedSearchParams);
      }
    };

    const createHub = async () => {
      setLoadingSubmit(true);
      try {
        const {
          data: { data },
        } = await addNewMiniHub(datas);
        createRacks(data.subHub.idToko, data.subHubId, data.id, data.name);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingSubmit(false);
      }
    };

    createHub();
  };

  const status = useSelector(getstatusMiniHubAdd);
  return (
    <Box sx={{ mt: "16px" }}>
      {/* parent add mini hub */}
      {!isCreateMap ? (
        <Box>
          {/* add mini hub */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              minHeight: "70vh",
            }}
          >
            <Grid container columns={12} spacing={3}>
              {/* mini hub name */}
              <Grid item xs={12}>
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{ fontSize: "17px", fontWeight: "bold", mb: 2 }}
                  >
                    Hub Name
                  </Typography>
                  <Typography sx={{ color: "red" }}>*</Typography>
                </Box>
                <CustomInput
                  fullWidth
                  sx={{
                    with: "100%",
                    bgcolor: "#fafafa",
                    "& .MuiOutlinedInput-input": {
                      padding: "17px 16px",
                      borderRadius: "10px",
                      "&::placeholder": {
                        color: "#111",
                        fontSize: "16px",
                      },
                    },
                    borderRadius: "5px",
                  }}
                  placeholder="enter hub name"
                  value={miniHubName}
                  onChange={(e) => {
                    if (e.target.value.length <= 30) {
                      dispatch(changeMiniHubName(e.target.value));
                    }
                  }}
                />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      mt: "5px",
                      ml: "15px",
                      color: "#9E9D9D",
                    }}
                  >
                    {miniHubName.length > 5 ? "" : "enter at least 5 charcters"}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      mt: "5px",
                      ml: "15px",
                      color: "#9E9D9D",
                    }}
                  >
                    {miniHubName.length}/30
                  </Typography>
                </Box>
              </Grid>

              {/* iamge */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                  <Box sx={{ display: "flex" }}>
                    <Typography sx={{ fontSize: "17px", fontWeight: "bold" }}>
                      Hub Photo
                    </Typography>
                    <Typography sx={{ color: "red" }}>*</Typography>
                  </Box>
                  <Typography sx={{ fontSize: "17px" }}>
                    (max size: 2MB)
                  </Typography>
                  {isMaxSizeImage && (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <ErrorOutlineIcon
                        sx={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: theme.palette.warning.main,
                          mr: "4px",
                        }}
                      />
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: theme.palette.warning.main,
                        }}
                      >
                        The photo can't be more than 2MB
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* add & preview */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  {/* preview */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {miniHubImage.length === 0 && (
                      <Box
                        sx={{
                          height: "54px",
                          width: "54px",
                          aspectRatio: "1/1",
                          borderRadius: "8px",
                          bgcolor: "#F5F5F5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderStyle: "dashed",
                          borderColor: "#9E9D9D",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          document.getElementById("input_img").click();
                        }}
                      >
                        <ImageOutlinedIcon
                          sx={{ color: "#9E9D9D", fontSize: "25px" }}
                        />
                      </Box>
                    )}
                    {miniHubImage.map((input, index) => (
                      <Box
                        sx={{
                          position: "relative",
                          overflow: "visible",
                          padding: "7px",
                        }}
                        key={index}
                      >
                        <CancelIcon
                          sx={{
                            position: "absolute",
                            fontSize: "20px",
                            top: 1,
                            right: 1,
                            zIndex: +1,
                            cursor: "pointer",
                          }}
                          onClick={() => dispatch(deleteMiniHubImage(input))}
                        />
                        <Box
                          component="img"
                          src={
                            process.env.REACT_APP_API_IMAGE_BASE_URL +
                            "/" +
                            input
                          }
                          sx={{
                            height: "54px",
                            width: "54px",
                            aspectRatio: "1/1",
                            borderRadius: "8px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            dispatch(clickIsPreviewImage());
                            dispatch(changeImagePreview(input));
                          }}
                        />
                      </Box>
                    ))}
                  </Box>

                  {/* add image */}
                  <Box
                    sx={{
                      display: "flex",
                      mb: "7px",
                      ml: "20px",
                      alignItems: "center",
                    }}
                  >
                    {miniHubImage.length < 3 && (
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: theme.palette.primary.main,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            document.getElementById("input_img").click();
                          }}
                        >
                          <input
                            accept="image/*"
                            id="input_img"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => dispatch(inputMiniHubImage(e))}
                          />
                          <AddIcon />
                          <Typography
                            sx={{ fontSize: "17px", fontWeight: "500" }}
                          >
                            Add More
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* video */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    pb: `${miniHubVideo.length === 0 ? "16px" : "9px"}`,
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Box sx={{ display: "flex" }}>
                        <Typography
                          sx={{ fontSize: "17px", fontWeight: "bold" }}
                        >
                          Video
                        </Typography>
                        <Typography sx={{ color: "red" }}>*</Typography>
                      </Box>
                      <Typography sx={{ fontSize: "17px" }}>
                        (max size: 100MB)
                      </Typography>
                    </Box>

                    {isMaxSizeVideo && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <ErrorOutlineIcon
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: theme.palette.warning.main,
                            mr: "4px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "8px",
                            fontWeight: "500",
                            color: theme.palette.warning.main,
                          }}
                        >
                          The video is too big
                        </Typography>
                      </Box>
                    )}

                    {errorMassageVideo && (
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <ErrorOutlineIcon
                          sx={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: theme.palette.warning.main,
                            mr: "4px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "10px",
                            fontWeight: "500",
                            color: theme.palette.warning.main,
                          }}
                        >
                          {errorMassageVideo}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* add & preview */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  {/* preview */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {miniHubVideo.length === 0 && (
                      <Box
                        sx={{
                          height: "54px",
                          width: "54px",
                          aspectRatio: "1/1",
                          borderRadius: "8px",
                          bgcolor: "#F5F5F5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderStyle: "dashed",
                          borderColor: "#9E9D9D",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          document.getElementById("input_video").click();
                        }}
                      >
                        <VideocamOutlinedIcon
                          sx={{ color: "#9E9D9D", fontSize: "25px" }}
                        />
                      </Box>
                    )}
                    {miniHubVideo.map((input, index) => (
                      <Box
                        sx={{
                          position: "relative",
                          overflow: "visible",
                          padding: "7px",
                        }}
                        key={index}
                      >
                        <CancelIcon
                          sx={{
                            position: "absolute",
                            fontSize: "20px",
                            top: 1,
                            right: 1,
                            zIndex: +1,
                            cursor: "pointer",
                          }}
                          onClick={() => dispatch(deleteVideoPreview(input))}
                        />
                        <Box
                          onClick={() => {
                            dispatch(clickIsVideoPreview());
                            dispatch(changeVideoPreview(input));
                          }}
                        >
                          <video
                            style={{
                              maxHeight: "54px",
                              maxWidth: "54px",
                              aspectRatio: "1/1",
                              borderRadius: "8px",
                              cursor: "pointer",
                              backgroundColor: "black",
                            }}
                          >
                            <source
                              src={
                                process.env.REACT_APP_API_IMAGE_BASE_URL +
                                "/" +
                                input +
                                "#t=0.5"
                              }
                            />
                          </video>
                        </Box>
                      </Box>
                    ))}
                  </Box>

                  {/* add video */}
                  <Box
                    sx={{
                      display: "flex",
                      mb: "7px",
                      ml: "20px",
                      alignItems: "center",
                    }}
                  >
                    {miniHubVideo.length < 3 && (
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: theme.palette.primary.main,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            document.getElementById("input_video").click();
                          }}
                        >
                          <input
                            // accept="video/*"
                            id="input_video"
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => dispatch(inputVideoPreview(e))}
                          />
                          {!isLoading ? (
                            <>
                              <AddIcon />
                              <Typography
                                sx={{ fontSize: "17px", fontWeight: "500" }}
                              >
                                Add More video
                              </Typography>
                            </>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <CircularProgress size={18} /> uploading...
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Grid>

              {/* PIC */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{ mb: 2, fontSize: "17px", fontWeight: "bold" }}
                  >
                    PIC
                  </Typography>
                  <Typography sx={{ color: "red" }}>*</Typography>
                </Box>
                <Autocomplete
                  options={picList}
                  value={picChoose}
                  inputValue={picSearch}
                  getOptionLabel={(option) => option.namaLengkap}
                  loading={picLoading}
                  onChange={(_, newValue) => {
                    dispatch(changePicChoose(newValue));
                    dispatch(changePicPhone(newValue.telpon));
                  }}
                  onInputChange={(_, newInputValue) => {
                    dispatch(changePicSearch(newInputValue));
                    picSearchInDebounce(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Search"
                      sx={{ bgcolor: "#fafafa", borderRadius: "5px" }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li key={option.idKustomer} {...props}>
                      {option.namaLengkap}
                    </li>
                  )}
                />
              </Grid>

              {/* phone number */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <Box sx={{ display: "flex" }}>
                  <Typography
                    sx={{ mb: 2, fontSize: "17px", fontWeight: "bold" }}
                  >
                    Phone Number
                  </Typography>
                  <Typography sx={{ color: "red" }}>*</Typography>
                </Box>
                <CustomInput
                  disabled
                  type="number"
                  placeholder="Enter Phone Number"
                  value={picChoose?.telpon || "-"}
                  sx={{
                    width: "100%",
                    bgcolor: "#fafafa",
                    borderRadius: "5px",
                  }}
                  // onChange={(e) => {
                  //   dispatch(changePicPhone(e.target.value));
                  // }}
                />
              </Grid>

              {/* address */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <CustomCard
                  sx={{ p: "8px 16px", cursor: "pointer" }}
                  onClick={() => setIsMapOpen(!isMapOpen)}
                >
                  <Box
                    sx={{
                      display: "center",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: "66px",
                          height: "66px",
                          bgcolor: "gray",
                          borderRadius: "8px",
                          position: "relative",
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            bgcolor: "white",
                            width: "100%",
                            height: "100%",
                            zIndex: "+2",
                            opacity: 0.5,
                          }}
                        ></Box>
                        <Box
                          sx={{
                            maxHeight: "66px",
                            overflow: "hidden",
                            borderRadius: "8px",
                          }}
                        >
                          <Map
                            defaultCenter={[
                              3.546958571415798, 98.6901696840363,
                            ]}
                            height={130}
                            defaultZoom={17}
                            width={66}
                            style={{
                              borderRadius: "8px",
                            }}
                          ></Map>
                        </Box>
                      </Box>
                      <Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            sx={{ fontWeight: "bold", mb: "4px", ml: "8px" }}
                          >
                            Address
                          </Typography>
                          <Typography sx={{ color: "red" }}>*</Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                          }}
                        >
                          <LocationOnIcon color="primary" />
                          <Typography>
                            {address ? address : "Click to enter address"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                    <KeyboardArrowDownIcon />
                  </Box>
                </CustomCard>
              </Grid>

              {/* rack */}
              <Grid item xs={6} sx={{ mt: 1 }}>
                <CustomCard
                  sx={{ p: "8px 16px", cursor: "pointer" }}
                  onClick={() => dispatch(changeIsCreateMap())}
                >
                  <Box
                    sx={{
                      display: "center",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          height: "66px",
                          borderRadius: "8px",
                        }}
                      ></Box>
                      <Box sx={{ ml: "8px" }}>
                        <Box sx={{ display: "flex" }}>
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontWeight: "bold",
                              mb: "10px",
                            }}
                          >
                            Racks Map
                          </Typography>
                          <Typography sx={{ color: "red" }}>*</Typography>
                        </Box>
                        <Typography sx={{ color: "#ccc", fontSize: "16px" }}>
                          Click to create map
                        </Typography>
                      </Box>
                    </Box>
                    <KeyboardArrowDownIcon />
                  </Box>
                </CustomCard>
              </Grid>
            </Grid>

            {/* submit */}
            <Box
              sx={{
                bottom: 1,
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                  Status
                </Typography>
                <CustomAntSwitch
                  value={status}
                  onChange={() => dispatch(changeStatus())}
                />
              </Box>

              <CustomButton
                variant="contained"
                // disabled={!isSubmitAvailable}
                onClick={handleSubmit}
                sx={{ width: "140px", height: "36px" }}
              >
                <Typography
                  sx={{ color: "white", fontSize: "12px", fontWeight: 500 }}
                >
                  Submit
                </Typography>
              </CustomButton>
            </Box>
          </Box>

          {/* dialog image */}
          <Dialog
            open={isImagePreview}
            onClose={() => {
              dispatch(clickIsPreviewImage());
              dispatch(changeImagePreview(""));
            }}
          >
            <Box
              component="img"
              src={
                process.env.REACT_APP_API_IMAGE_BASE_URL +
                "/" +
                linkPhotoPreview
              }
              sx={{ width: "600px", height: "600px", aspectRation: "1/1" }}
            />
          </Dialog>

          {/* dialog video */}
          <Dialog
            open={isVideoPreview}
            onClose={() => {
              dispatch(clickIsVideoPreview());
              dispatch(changeVideoPreview(""));
            }}
          >
            <Box sx={{ bgcolor: "black" }}>
              <video
                style={{
                  width: "600px",
                  height: "600px",
                  backgroundColor: "black",
                }}
                controls
              >
                <source
                  src={
                    process.env.REACT_APP_API_IMAGE_BASE_URL +
                    "/" +
                    linkVideoPreview
                  }
                />
              </video>
            </Box>
          </Dialog>

          {/* dialog address */}
          <Dialog
            open={isMapOpen}
            onClose={() => {
              setIsMapOpen(!isMapOpen);
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>Input Address</Box>
              <CloseIcon
                sx={{ cursor: "pointer" }}
                onClick={() => setIsMapOpen(false)}
              />
            </DialogTitle>
            <DialogContent dividers>
              <SetupAddressMiniHub setIsOpen={setIsMapOpen} />
            </DialogContent>
          </Dialog>
        </Box>
      ) : (
        <CreateMapMiniHub />
      )}
    </Box>
  );
}
export default FormMiniHubAdd;
